<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="reportCode" label="报告编号">
        <el-input
          v-model="searchModel.reportCode"
          placeholder="输入报告编号"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="client" label="委托单位">
        <el-input
          v-model.trim="searchModel.client"
          placeholder="请输入"
          clearable
          @keyup.enter.native="handleQuery(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="handleQuery(true)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-show="!collapsed" prop="orderType" label="排序规则">
        <el-select v-model="searchModel.orderType" placeholder="请选择" clearable @change="handleQuery(true)">
          <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="handleQuery(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="text" class="search-isOpen" @click="collapsed = !collapsed">
          {{ collapsed ? '展开' : '收起' }}
          <i class="el-icon--right" :class="collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
        </el-button>
      </el-form-item>
    </el-form>

    <keep-alive>
      <component ref="tableComponent" :is="TableComponent" :key="tableType" :deliverState="deliverState">
        <div class="type-group">
          <div
            v-for="item in typeList"
            :key="item.value"
            :class="{ 'type-item': true, activated: tableType == item.value }"
            @click="tableType = item.value"
          >
            {{ item.label }}
          </div>
        </div>
      </component>
    </keep-alive>
  </div>
</template>

<script>
import TableExperiment from './components/TableExperiment';
import TableProcess from '@/views/taskAllocation/components/TableProcess'; // 试验进度

export default {
  components: { TableExperiment, TableProcess },
  data() {
    return {
      collapsed: true,
      searchModel: {
        reportCode: '',
        client: '',
        sampleName: '',
        itemName: null,
        orderType: 2,
        dateRange: []
      },
      orderTypeOptions: [
        {
          value: 2,
          label: '编号降序'
        },
        {
          value: 3,
          label: '编号升序'
        },
        {
          value: 0,
          label: '创建时间降序'
        },
        {
          value: 1,
          label: '创建时间升序'
        }
      ],
      tableType: 'table0',
      deliverState: '0',
      typeList: [
        {
          label: '编制中',
          value: 'table0',
          deliverState: '0'
        },
        {
          label: '审核中',
          value: 'table2',
          deliverState: '2'
        },
        {
          label: '审核退回',
          value: 'table3',
          deliverState: '-3'
        },
        {
          label: '已完成',
          value: 'table4',
          deliverState: '3'
        },
        {
          label: '报告进度',
          value: 'table5'
        }
      ],
      TableComponent: 'TableExperiment'
    };
  },
  computed: {},
  watch: {
    tableType(val, oldval) {
      switch (val) {
        case 'table0':
        case 'table1':
        case 'table2':
        case 'table3':
        case 'table4':
          this.deliverState = this.typeList.find(item => item.value === this.tableType).deliverState;
          this.TableComponent = 'TableExperiment';
          break;
        case 'table5':
          this.TableComponent = 'TableProcess';
          break;
      }
    }
  },
  methods: {
    handleQuery() {
      this.$refs.tableComponent.setSearchModel(this.searchModel);
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.$refs.tableComponent.setSearchModel(this.searchModel);
    }
  }
};
</script>

<style lang="scss" scoped>
.type-group {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  font-size: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;

  .type-item {
    display: inline-block;
    padding: 9px 15px;
    font-size: 12px;
    border-right: 1px solid #dcdfe6;
    border-radius: 0;
    cursor: pointer;

    &:last-of-type {
      border-right: none;
    }
    &.activated {
      color: #ffffff;
      background-color: #009688;
      border-color: #009688;
    }
  }
}
</style>
